'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function createNullLogger() {
    return {
        debug(_message, _args) {
            return Promise.resolve();
        },
        info(_message, _args) {
            return Promise.resolve();
        },
        error(_message, _args) {
            return Promise.resolve();
        },
    };
}

const LogLevelEnum = {
    Debug: 1,
    Info: 2,
    Error: 3,
};

exports.LogLevelEnum = LogLevelEnum;
exports.createNullLogger = createNullLogger;
